import Plus from '@/app/_components/ui/icons/Plus.svg';
import SmallClose from '@/app/_components/ui/icons/SmallClose.svg';
import React from 'react';
import { useRef } from 'react';

export default function ArrayInput(props) {
  const refInput = useRef(null);
  const {
    register,
    errors,
    name,
    label,
    required,
    onChange,
    addItem,
    removeItem,
    items,
    cons,
  } = props;

  const addItemAndClearInput = () => {
    if (!refInput.current || refInput.current.value == '') {
      return;
    } else {
      addItem();
      refInput.current.value = '';
    }
  };
  return (
    <>
      <label
        className="block uppercase tracking-wide text-gray-900 text-sm  font-bold mb-2"
        htmlFor="unit"
      >
        {label}
        {required && <span className="text-red-500">*</span>}
      </label>
      <div className="relative">
        <input
          className="appearance-none block w-full text-sm text-gray-900 border border-light-gray-200 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
          {...register(`${name}`)}
          type="text"
          placeholder={props.placeholder || label}
          onChange={onChange}
          ref={refInput}
        />
        <button
          type="button"
          className=" absolute top-2.5 left-2.5"
          onClick={addItemAndClearInput}
        >
          <Plus stroke="#292D32" />
        </button>
        <span className=" inputValidation text-xs text-red-800">
          {errors[name]?.message}
        </span>
      </div>
      <div className="flex items-center mt-2">
        {items.length != 0 &&
          items.map((item, index) => (
            <div
              className={`${
                cons
                  ? 'text-Outrageous-Orange bg-orange-light'
                  : 'text-light-green-400 bg-light-green-50'
              }  text-xs flex items-center py-1 px-2 rounded-xl ml-2`}
              key={index}
            >
              <button
                type="button"
                className="remove-add-item"
                onClick={() => removeItem(item)}
              >
                <SmallClose fill={`${cons ? '#FF5C39' : '#12B76A'}`} />
              </button>
              <span>{item}</span>
            </div>
          ))}
      </div>
    </>
  );
}
